/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_kGBMcKmWm",
    "aws_user_pools_web_client_id": "4c2asnikb7babsshs4kuih3ikv",
    "oauth": {
        "domain": "everyset-casting-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:8081,https://casting-dev.everyset.com,https://casting-redesign-dev.everyset.com,https://jobs-dev.everyset.com,https://jobs-redesign-dev.everyset.com,https://oauth-dev.everyset.com/oauth2/idpresponse",
        "redirectSignOut": "http://localhost:8081,https://casting-dev.everyset.com,https://casting-redesign-dev.everyset.com,https://jobs-dev.everyset.com,https://jobs-redesign-dev.everyset.com",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
